import './public.css';
export default function Input({
    placeholder,
    inputMode = "text",
    value,
    onChange,
    type = "text",
    className = "",
    disabled = false,
    ...props
  }) {
    return (
      <input
        type={type}
        inputMode={inputMode}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`
          h-[50px]
          w-full
          p-3
          pl-4
          pr-3
          bg-input
          dark:bg-neutral-900
          border-2
          border-border
          dark:border-neutral-700
          rounded-none
          shadow-none
          placeholder-muted-foreground
          focus:outline-none
          focus:border-foreground
          dark:focus:border-neutral-300
          transition-colors
          duration-150
          text-foreground
          dark:text-neutral-100
          ${className}
        `}
        disabled={disabled}
        {...props}
      />
    );
  }